import React from 'react';
import StyledSelect from '../../StyledSelect';

const UserModals = ({
  editUserData,
  handleConfirmDeleteUser,
  handleUpdateUser,
  selectedUser,
  setEditUserData,
  setShowDeleteUser,
  setShowEditUser,
  showDeleteUser,
  showEditUser,
  teamLeaders
}) => {
  return (
    <>
{showEditUser && selectedUser && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
              <h2 className="text-2xl font-bold text-slate-800 mb-6">
                Benutzer bearbeiten
              </h2>
              <form onSubmit={handleUpdateUser} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    value={editUserData.name}
                    onChange={(e) => setEditUserData({ ...editUserData, name: e.target.value })}
                    className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    E-Mail
                  </label>
                  <input
                    type="email"
                    value={editUserData.email}
                    onChange={(e) => setEditUserData({ ...editUserData, email: e.target.value })}
                    className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Rolle
                  </label>
                  <StyledSelect
                    value={editUserData.role}
                    onChange={(e) => setEditUserData({ ...editUserData, role: e.target.value })}
                    variant="slate"
                    required
                  >
                    <option value="vertriebler">Vertriebler</option>
                    <option value="teamleiter">Teamleiter</option>
                    <option value="vertriebsleiter">Vertriebsleiter</option>
                    <option value="backoffice">Backoffice</option>
                    <option value="admin">Administrator</option>
                  </StyledSelect>
                </div>
                {/* Team Leader Assignment - only show for vertriebler role */}
                {editUserData.role === 'vertriebler' && (
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Teamleiter zuweisen
                    </label>
                    <StyledSelect
                      value={editUserData.managed_by}
                      onChange={(e) => setEditUserData({ ...editUserData, managed_by: e.target.value })}
                      variant="slate"
                    >
                      <option value="">Kein Teamleiter zugewiesen</option>
                      {teamLeaders.map((leader) => (
                        <option key={leader.id} value={leader.id}>
                          {leader.name} ({leader.email})
                        </option>
                      ))}
                    </StyledSelect>
                  </div>
                )}
                <div className="flex justify-end space-x-4 pt-6">
                  <button
                    type="button"
                    onClick={() => setShowEditUser(false)}
                    className="px-6 py-3 text-slate-700 bg-slate-200 hover:bg-slate-300 rounded-xl font-medium transition-colors"
                  >
                    Abbrechen
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium transition-colors shadow-lg hover:shadow-xl"
                  >
                    Speichern
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

{showDeleteUser && selectedUser && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
              <h2 className="text-2xl font-bold text-slate-800 mb-6">
                Benutzer löschen
              </h2>
              <p className="text-slate-600 mb-8">
                Sind Sie sicher, dass Sie den Benutzer <strong>{selectedUser.name}</strong> ({selectedUser.email}) löschen möchten?
                Diese Aktion kann nicht rückgängig gemacht werden.
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setShowDeleteUser(false)}
                  className="px-6 py-3 text-slate-700 bg-slate-200 hover:bg-slate-300 rounded-xl font-medium transition-colors"
                >
                  Abbrechen
                </button>
                <button
                  onClick={handleConfirmDeleteUser}
                  className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-xl font-medium transition-colors shadow-lg hover:shadow-xl"
                >
                  Löschen
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default UserModals;
